"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.view = void 0;
function view(props) {
    var _this = this;
    return {
        state: {
            hasImg: (this.props.imgUrl != ""),
            isStepProgressShown: getIsStepProgressShown(this.props),
        },
        initialize: function () {
            return new Promise(function (resolve) {
                resolve();
            });
        },
        mounted: function () {
        },
        receivedProps: function (nextProps) {
            return new Promise(function (resolve) {
                _this.view.state.hasImg = (nextProps.imgUrl != "");
                _this.view.state.isStepProgressShown = getIsStepProgressShown(nextProps);
                resolve();
            });
        },
        unmount: function () {
        },
        events: {}
    };
}
exports.view = view;
function getIsStepProgressShown(_a) {
    var totalPages = _a.totalPages, currentPage = _a.currentPage;
    return totalPages >= currentPage && totalPages !== 1;
}



//////////////////
// WEBPACK FOOTER
// C:/TeamCity/buildAgent2/work/8b1685a0cde68c49/src/.tmp/ApplicationTitleHeader/View.js
// module id = 556
// module chunks = 0